__turbopack_context__.v({
  "Separator": "z6oDUW_Separator",
  "body": "z6oDUW_body",
  "deleteBtn": "z6oDUW_deleteBtn",
  "details": "z6oDUW_details",
  "expItem": "z6oDUW_expItem",
  "link": "z6oDUW_link",
  "logo": "z6oDUW_logo",
  "primaryLabel": "z6oDUW_primaryLabel",
  "row": "z6oDUW_row",
  "secondaryLabel": "z6oDUW_secondaryLabel",
});
